export const getSelectedParticipants = (participants: Map<number, boolean>): number[] => {
    return Array.from(participants.entries())
        .filter(([_, selected]) => selected)
        .map(([id]) => id);
};
